import { Injectable } from '@angular/core';
import { NGXLogger } from 'ngx-logger';
import { Storage } from '@ionic/storage-angular';

@Injectable({
  providedIn: 'root',
})
export class StorageService {
  private store: Storage | null = null;

  constructor(
    private log: NGXLogger,
    private storeService: Storage
  ) {
    this.init();
  }

  public set(key: string, value: any) {
    return this.store?.set(key, value);
  }
  // public get(key: string, defaultValue?: any): Promise<any> {
  //   return this.store?.get(key).catch((err) => {
  //     if (defaultValue) {
  //       return defaultValue;
  //     } else {
  //       return null;
  //     }
  //   });
  // }
  public async get(key: string): Promise<any> {
    const data = await this.store?.get(key);
    return data;
  }

  public async remove(key: string): Promise<any> {
    const data = await this.store?.remove(key);
    return data;
  }
  private async init() {
    this.store = await this.storeService.create();
  }

  public async clear() {
    return this.store?.clear();
  }
}
